import { useState, useEffect, useMemo } from 'preact/hooks';
import Config from '../config';
import { MiddlewareAuthService } from './MiddlewareAuthService';
import { TelegramIcon } from '../../skins/awrabet/utils/icons';
import User from '../user';

export function useTelegramSDK() {
    const [isLoaded, setIsLoaded] = useState(!!window.Telegram?.Login);

    useEffect(() => {
        if (window.Telegram?.Login) return;

        const script = document.createElement('script');
        script.src = "https://oauth.telegram.org/js/telegram-login.js?3";
        script.async = true;
        script.onload = () => setIsLoaded(true);
        document.head.appendChild(script);
    }, []);

    return isLoaded;
}

export function shouldAskTelegram() {
    return Config.telegramLogin && !!User.data && !User.data.notifications
}

interface TelegramButtonProps {
    clientId: string | number;
    onSuccess: (idToken: string) => void;
    onError: (err: string) => void;
    shape?: 'square' | 'circle';
    iconOnly?: boolean;
    text?: string;
    class?: string; // Per override extra
}

export const TelegramButton = ({ clientId, onSuccess, onError, shape, iconOnly, text, ...props }: TelegramButtonProps) => {
    const isSDKReady = useTelegramSDK();
    const softionTgApi = useMemo(() => new MiddlewareAuthService(Config.softionAPI), [Config.softionAPI]);

    const handleLogin = () => {
        if (!isSDKReady) {
            console.warn("Telegram SDK not loaded yet");
            return;
        }

        // Chiamata programmatica
        window.Telegram.Login.auth({
            client_id: parseInt(String(clientId)),
            request_access: ['phone', 'write'] // Chiediamo esplicitamente il telefono
        }, (data) => {
            if ('error' in data) {
                onError(data.error);
            } else {
                // Passiamo il JWT al genitore che lo invierà al backend Vert.x
                softionTgApi.openIdConnectLogin(data.id_token)
                    .then((data) => {
                        if (data.success)
                            onSuccess("")
                        else
                            onError(data.error)
                    })
                    .catch((err) => onError(err))
            }
        });
    };
    // Classi per il bottone rettangolare (Screenshot 2)
    const fullBtnClasses = "px-[18px] py-[10px] rounded-[4px] space-x-[10px]";

    // Classi per il bottone quadrato (Screenshot 1)
    const iconBtnClasses = iconOnly ? '' : "w-[40px] h-[40px] rounded-[8px]";

    const baseClasses = `
    inline-flex items-center justify-center 
    bg-[#24A1DE] hover:bg-[#1e96c8] 
    text-white transition-colors duration-200
    font-sans text-[14px] font-medium
    active:opacity-90 disabled:opacity-50
  `;

    return (
        <button
            onClick={handleLogin}
            disabled={!isSDKReady}
            className={`${baseClasses} ${iconOnly ? iconBtnClasses : fullBtnClasses} ${props['class']}`}
        >
            {/* Icona Aeroplano Bianca (Esatta come da widget) */}
            <TelegramIcon class="h-4" />

            {!iconOnly && <span className="leading-none">{text}</span>}
        </button>
    );
};